import React from 'react';
import { IconChevronRight } from '@noths/polaris-client-ribbons-design-system';

import * as styles from 'client-site-chrome-ui/components/molecules/NavigationDrilldown/styles/NavigationDrilldownList.styles';
import { useTracking } from 'client-site-chrome-ui/components/molecules/NavigationDrilldown/hooks/useTracking/useTracking';
import type { DrilldownNavItem } from 'client-site-chrome-ui/types/drilldownNavItem';

const ICON_SIZE = 16;

interface NavigationDrilldownListProps {
  disabled: boolean;
  expandedIndex: number | null;
  getExpandedIndex?: (level: number) => number | null;
  items: DrilldownNavItem[];
  level?: number;
  onSelect: (item: DrilldownNavItem) => void;
  setExpandedIndex: (index: number | null, level?: number) => void;
}

export const NavigationDrilldownList = ({
  disabled,
  expandedIndex,
  getExpandedIndex,
  items,
  level = 0,
  onSelect,
  setExpandedIndex,
}: NavigationDrilldownListProps) => {
  const tracking = useTracking();

  return (
    <ul css={styles.list}>
      {items?.map((item, idx) => {
        return (
          <li
            key={item.title}
            style={
              {
                '--color': item.color,
              } as styles.NavigationDrilldownButtonCSSProperties
            }
          >
            {item.url && (!item.items || item.items.length === 0) ? (
              // Leaf node: render as link
              <a
                css={[
                  styles.button,
                  styles.link,
                  item.role === 'see_all_link' && styles.seeAllLink,
                ]}
                href={item.url}
                onClick={(evt) => tracking.onClickLink(evt, item)}
                tabIndex={disabled ? -1 : 0}
              >
                {item.title}
              </a>
            ) : (
              // Has children: render as button to drill down
              <>
                <button
                  css={styles.button}
                  disabled={disabled}
                  onClick={() => {
                    onSelect(item);
                    tracking.onSelect(item);
                    setExpandedIndex(expandedIndex === idx ? null : idx, level);
                  }}
                >
                  {item.title}
                  <IconChevronRight height={ICON_SIZE} width={ICON_SIZE} />
                </button>
                {item.items && item.items.length > 0 && expandedIndex === idx && (
                  <>
                    <NavigationDrilldownList
                      disabled={disabled}
                      expandedIndex={getExpandedIndex ? getExpandedIndex(level + 1) : null}
                      getExpandedIndex={getExpandedIndex}
                      items={item.items}
                      level={level + 1}
                      onSelect={onSelect}
                      setExpandedIndex={setExpandedIndex}
                    />
                  </>
                )}
              </>
            )}
          </li>
        );
      })}
    </ul>
  );
};
